import { useQuery } from "@tanstack/react-query";

import { permissionsQuery } from "#modules/permissions/infra/permissions.query";

export const usePermissions = () => {
  const { data: permissions = [], ...rest } = useQuery(permissionsQuery());

  return { permissions, ...rest };
};
